"use strict";

exports.__esModule = true;
exports.getAvailableTimingOptions = getAvailableTimingOptions;
exports.getAvailableDeliveryInfos = getAvailableDeliveryInfos;
exports.getAsapParams = getAsapParams;
exports.getAsapParamsTakeout = getAsapParamsTakeout;
exports.getAsapParamsDelivery = getAsapParamsDelivery;
exports.getDaysDiff = getDaysDiff;
exports.getFinalAvailability = getFinalAvailability;
exports.getTimeOptions = exports.getDateOptions = void 0;

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _lodash = _interopRequireDefault(require("lodash"));

var _Status = _interopRequireDefault(require("@wix/wixrest-utils/dist/openrest-helpers/Status"));

var _unionAvailabilites = require("./unionAvailabilites");

var _availability = require("availability");

var _restaurantLogic = require("./restaurantLogic");

var _simpleMemoize = require("./simpleMemoize");

var _BusinessNotifications = require("../types/BusinessNotifications");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getAvailableTimingOptions(restaurant, dispatchType, dispatchTime, idealDeliveryArea, businessNotification) {
  var _restaurant$orders$fu, _dateOptions$, _dateOptions$2, _earliestTimeOptions$;

  const timezone = restaurant.timezone;
  const initialTime = (0, _momentTimezone.default)(dispatchTime).tz(timezone);
  const numberOfDays = ((_restaurant$orders$fu = restaurant.orders.future.delayMins) == null ? void 0 : _restaurant$orders$fu.max) / 1440;
  const finalAvailability = getFinalAvailability(restaurant, dispatchType, idealDeliveryArea);
  const dateOptions = getDateOptions({
    availability: finalAvailability,
    timezone,
    numberOfDays,
    delayMins: restaurant.orders.future.delayMins
  });
  const selectedDate = dispatchTime ? initialTime.startOf('day').valueOf() : (_dateOptions$ = dateOptions[0]) == null ? void 0 : _dateOptions$.timestamp;
  const earliestTimeOptions = (_dateOptions$2 = dateOptions[0]) != null && _dateOptions$2.timestamp ? getTimeOptions({
    availability: finalAvailability,
    day: selectedDate,
    timezone,
    delayMins: restaurant.orders.future.delayMins
  }) : [];
  const isOnlyAsap = restaurant.orders.future.disabled && !restaurant.orders.asap.disabled;
  const isOnlyFutureOrders = dispatchType === 'delivery' ? businessNotification && businessNotification === _BusinessNotifications.BusinessNotifications.OnlyFutureOrders : !restaurant.orders.future.disabled && ((_earliestTimeOptions$ = earliestTimeOptions[0]) == null ? void 0 : _earliestTimeOptions$.timestamp) && (0, _momentTimezone.default)(earliestTimeOptions[0].timestamp).tz(timezone) > (0, _momentTimezone.default)().tz(timezone).add(restaurant.orders.future.delayMins.min + 15, 'minutes');
  const isBoth = !isOnlyFutureOrders && !restaurant.orders.future.disabled && !restaurant.orders.asap.disabled;

  if (isOnlyAsap) {
    return ['asap'];
  } else if (isOnlyFutureOrders) {
    return ['later'];
  } else if (isBoth) {
    return ['asap', 'later'];
  }

  return [];
}

function getAvailableDeliveryInfos(deliveryInfos) {
  return deliveryInfos.filter(deliveryInfo => {
    const _StatusHelper$getStat = _Status.default.getStatus(deliveryInfo.availability, (0, _momentTimezone.default)()),
          status = _StatusHelper$getStat.status,
          reason = _StatusHelper$getStat.reason;

    const isClosed = status === 'unavailable' && reason === 'closed';
    return deliveryInfo.inactive !== false && !isClosed;
  });
}

function getAsapParams({
  idealDeliveryArea,
  deliveryInfos,
  dispatchType
}) {
  const availableDeliveryInfos = getAvailableDeliveryInfos(deliveryInfos);
  return dispatchType === 'delivery' ? getAsapParamsDelivery(availableDeliveryInfos, idealDeliveryArea) : getAsapParamsTakeout(availableDeliveryInfos);
}

function getAsapParamsTakeout(deliveryInfos) {
  const takeout = _lodash.default.find(deliveryInfos, info => info.type === 'takeout');

  let type, value;

  if (!takeout) {
    type = 'invalid';
  } else if (takeout.inactive) {
    type = 'unavailable';
  } else {
    type = takeout.delayMins !== 0 ? 'exact' : 'immediate';
    value = takeout.delayMins;
  }

  return {
    type,
    value
  };
}

function getAsapParamsDelivery(deliveryInfos, idealDeliveryArea) {
  const delayMins = idealDeliveryArea ? [idealDeliveryArea.delayMins || 0] : (0, _restaurantLogic.getDelayMins)({
    deliveryInfos,
    dispatchType: 'delivery'
  });
  let type;

  if (delayMins.length === 0) {
    return {
      type: 'unavailable'
    };
  } else if (delayMins.length === 1) {
    type = delayMins[0] === 0 ? 'immediate' : 'exact';
    return {
      type,
      value: delayMins[0]
    };
  } else {
    const min = _lodash.default.min(delayMins);

    const max = _lodash.default.max(delayMins);

    if (min === 0) {
      return {
        type: 'exact',
        value: max
      };
    } else {
      return {
        type: 'range',
        min,
        max
      };
    }
  }
}

const _isAvailableOn = (0, _simpleMemoize.simpleMemoize)((availability, time) => (0, _availability.isAvailableOn)(availability, time));

function isAvailableSomeTimeOnDay(availability, day, timezone, delayMins, dishPrepareTime) {
  const timeOptions = getTimeOptions({
    availability,
    day,
    timezone,
    delayMins,
    dishPrepareTime
  });
  return timeOptions.length > 0 && getDaysDiff(timeOptions[0].timestamp, timezone, day) === 0;
}

const getDateOptions = (0, _simpleMemoize.simpleMemoize)(({
  numberOfDays = 7,
  availability = {},
  timezone,
  delayMins,
  dishPrepareTime
}) => {
  const result = [];
  const minimalWaitTime = Math.max((delayMins == null ? void 0 : delayMins.min) || 0, dishPrepareTime || 0);
  const startDate = (0, _momentTimezone.default)().tz(timezone).add(minimalWaitTime, 'minutes').startOf('day');

  for (let i = 0; i < numberOfDays; i++) {
    const day = startDate.clone().add(i, 'days');

    if (delayMins && day.diff(startDate, 'minutes') > delayMins.max - minimalWaitTime) {
      break;
    }

    if (isAvailableSomeTimeOnDay(availability, day.valueOf(), timezone, delayMins, dishPrepareTime)) {
      result.push({
        timestamp: day.toDate().getTime(),
        displayableValue: day.format('MMMM Do')
      });
    }
  }

  return result;
});
exports.getDateOptions = getDateOptions;
const getTimeOptions = (0, _simpleMemoize.simpleMemoize)(({
  day,
  timezone,
  locale = '',
  availability = {},
  delayMins,
  dishPrepareTime
}) => {
  const result = [];
  const earliest = (0, _momentTimezone.default)().tz(timezone).add(Math.max((delayMins == null ? void 0 : delayMins.min) || 0, dishPrepareTime || 0), 'minutes');
  const isAtEarliestDay = getDaysDiff(day, timezone, earliest.valueOf()) === 0;
  const anchor = isAtEarliestDay ? getRoundedMinutesValue(earliest) : (0, _momentTimezone.default)(day).tz(timezone).startOf('day');
  const endOfDay = anchor.clone().endOf('day');
  const endAnchor = delayMins ? _momentTimezone.default.min((0, _momentTimezone.default)().add(delayMins.max, 'minutes'), endOfDay) : endOfDay;

  while (anchor.valueOf() < endAnchor.valueOf()) {
    if (_isAvailableOn(availability, anchor)) {
      result.push({
        timestamp: anchor.valueOf(),
        displayableValue: anchor.locale(locale).format('LT')
      });
    }

    anchor.add(15, 'minutes');
  }

  return result;
});
exports.getTimeOptions = getTimeOptions;

function getRoundedMinutesValue(m, interval = 15) {
  if (interval <= 0 || interval > 60) {
    throw new Error(`Invalid interval ${interval}`);
  }

  const roundedMinutes = Math.ceil(m.minute() / interval) * interval;
  return m.clone().minute(roundedMinutes).seconds(0).milliseconds(0);
}

function getDaysDiff(timestamp, timezone, comparedTo) {
  return (0, _momentTimezone.default)(timestamp).tz(timezone).startOf('day').diff((0, _momentTimezone.default)(comparedTo).tz(timezone).startOf('day'), 'day');
}

function getAvailabilitiesByDispatchType(restaurant, dispatchType) {
  const deliveryInfos = getAvailableDeliveryInfos(restaurant.deliveryInfos);
  return deliveryInfos.filter(di => di.type === dispatchType).map(di => di.availability);
}

function getFinalAvailability(restaurant, dispatchType, selectedDeliveryArea, includeExceptions) {
  const availabilities = selectedDeliveryArea && dispatchType === 'delivery' ? [selectedDeliveryArea.availability] : getAvailabilitiesByDispatchType(restaurant, dispatchType);

  const _intersectWeeklyAvail = (0, _availability.intersectWeeklyAvailabilities)(restaurant.openTimes, (0, _unionAvailabilites.unionWeeklyAvailabilities)(availabilities)),
        weekly = _intersectWeeklyAvail.weekly;

  const exceptions = (0, _unionAvailabilites.unionAvailabilityExceptions)([restaurant.openTimes, ...availabilities]);
  const filteredExceptions = exceptions.filter(e => e.available || includeExceptions);
  const result = {
    weekly: (weekly || []).filter(x => x.durationMins > 0)
  };

  if (filteredExceptions.length > 0) {
    result.exceptions = filteredExceptions;
  }

  return result;
}
//# sourceMappingURL=dateTimeLogic.js.map